"use strict";
exports.__esModule = true;
exports.chart_color_gold_100 = {
  "name": "--pf-v5-chart-color-gold-100",
  "value": "#f9e0a2",
  "var": "var(--pf-v5-chart-color-gold-100, #f9e0a2)"
};
exports["default"] = exports.chart_color_gold_100;